import { render, staticRenderFns } from "./AdminWallet.vue?vue&type=template&id=61a358ab&scoped=true&"
import script from "./AdminWallet.vue?vue&type=script&lang=js&"
export * from "./AdminWallet.vue?vue&type=script&lang=js&"
import style0 from "./AdminWallet.vue?vue&type=style&index=0&id=61a358ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a358ab",
  null
  
)

export default component.exports